import React, { Component } from 'react';
import { connect } from 'react-redux';
import CreateBusinessCard from '../Components/CreateBusinessCard';
import { toggle, update, adjustBusinessCard, addDynamicProductToCart } from '../Actions/CreateBusinessCard.action';

//const CreateBusinessCardContainer = props => (<CreateBusinessCard {...props} />) 
//const mapStateToProps = state => ({ ...state.createBusinessCard })

//export default connect(
//    mapStateToProps,
//    {
//        toggle,
//        update,
//        generateBusinessCard
//    }
//)(CreateBusinessCardContainer);

class CreateBusinessCardContainer extends Component {
    constructor(props) {
        super(props);
        this.state = { ...props };
        this.formEl = document.getElementById("createBusinessCardForm");
        this.adjustBusinessCardButton = document.getElementById("adjustBusinessCardButton");
    }

    componentDidMount() {
        // Listen to form field blur
        if (this.formEl) {
            this.formEl.addEventListener('blur', this.onBlur, true);
        }
        if (this.adjustBusinessCardButton) {
            this.adjustBusinessCardButton.addEventListener('click', this.adjustBusinessCardClick, true);
        }

    }
    componentWillUnmount() {
        if (this.formEl) {
            this.formEl.removeEventListener('blur', this.onBlur);
        }
        if (this.adjustBusinessCardButton) {
            this.adjustBusinessCardButton.removeEventListener('click', this.adjustBusinessCardClick);
        }
    }

    onBlur() {
        //alert("blur");
    }

    adjustBusinessCardClick() {
        //const $columbusBusinessCardPdfEl = document.getElementById("createBusinessCard");

        //if ($columbusBusinessCardPdfEl) {
        //    const variantId = $columbusBusinessCardPdfEl.getAttribute("data-variant-id");
        //    if (variantId) {
        //        adjustBusinessCard(variantId);
        //    }
        //}
    }

    render() {

        return (
            <CreateBusinessCard {...this.props} />
        );
    }
}
 


//const mapStateToProps = state => {
//    return {
//        isPreview: state.createBusinessCard.isPreview,
//    }
//}

const mapStateToProps = state => ({ ...state.createBusinessCard })

const mapDispatchToProps = dispatch => {
    return {
        generateBusinessCard: () => dispatch(generateBusinessCard()),
        addDynamicProductToCart: () => dispatch(addDynamicProductToCart()),
        adjustBusinessCard: (id) => dispatch(adjustBusinessCard(id)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateBusinessCardContainer); 